import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxsModule } from '@ngxs/store';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { LanguageService } from './services/language.service';
// import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_LANGUAGE, RecaptchaFormsModule } from "ng-recaptcha";

import { AuthInterceptorService } from './services/interceptors/auth-interceptor.service';
// TODO(mock): eliminar este import junto con MockRoomInterceptor cuando el detalle
// de room sirva datos reales (ver mock-room.interceptor.ts).
import { MockRoomInterceptor } from './services/interceptors/mock-room.interceptor';
import { MetadataService } from './services/metadata/metadata.services';
import { PaymentService } from './services/payments/payment.service';
import { CommonProvider } from './services/common/common.provider';
import { UserService } from './services/users/users.service';
import { environment } from './../environments/environment';
import { ThreeState } from './store/three/three.state';
import { FormService } from './services/form.service';
import { ItemState } from './store/item.state';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';

import { NotFoundPageComponent } from './shared/pages/not-found-page/not-found-page.component';
import { ErrorLayoutComponent } from './shared/layouts/error-layout/error-layout.component';
import { AppComponent } from './app.component';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { UiState } from './store/ui/ui.state';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Cache-busting: timestamp generado en build time
const BUILD_TIMESTAMP = new Date().getTime();

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", `.json?v=${BUILD_TIMESTAMP}`);
}

@NgModule({ declarations: [
        AppComponent,
        ErrorLayoutComponent,
        NotFoundPageComponent,
        MaintenancePageComponent,
    ],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        AppRoutingModule,
        // RecaptchaV3Module,
        // RecaptchaFormsModule,
        NgScrollbarModule,
        NgxsModule.forRoot([ItemState, ThreeState, UiState], {
            developmentMode: !environment.production,
        }),
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        })], providers: [
        CookieService,
        {
            provide: APP_INITIALIZER,
            useFactory: (languageService: LanguageService) => () => languageService.init(),
            deps: [LanguageService],
            multi: true,
        },
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true,
        },
        // TODO(mock): eliminar este provider cuando exista el endpoint real de rooms.
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MockRoomInterceptor,
            multi: true,
        },
        // {
        //   provide: RECAPTCHA_LANGUAGE,
        //   useValue: "es",
        // },
        // {
        //   provide: RECAPTCHA_V3_SITE_KEY,
        //   useValue: '6LdMtngaAAAAADm3dthutPIO4UBGiR6aP4nqV9t'
        // },
        NgbActiveModal,
        UserService,
        MetadataService,
        ToastrService,
        FormService,
        CommonProvider,
        PaymentService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
